import { FC } from 'react';

import { faChartBar } from '@fortawesome/pro-light-svg-icons';

import { IconDefinition } from '@fortawesome/fontawesome-common-types';

import { Box, Stack, Typography } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

interface NoDataPlaceholderProps {
  title?: string;
  icon?: IconDefinition;
  height?: string | number;
}

const NoDataPlaceholder: FC<NoDataPlaceholderProps> = ({
  title,
  icon = faChartBar,
  height = 400
}) => {
  return (
    <Box
      height={height}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Stack spacing={2} justifyContent="center">
        <Box mx="auto">
          <FontAwesomeSvgIcon icon={icon} fontSize="large" />
        </Box>
        <Typography>{title}</Typography>
      </Stack>
    </Box>
  );
};

export default NoDataPlaceholder;
